import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { formatMoney } from "@/pages/InvoiceManagement/utils/money";
import { V2_COLORS } from "@/pages/InvoiceManagement/v2/constants/colors";
import type { VendorRfqDetail } from "../../types";
import { formatDay, formatRespondBy } from "../../utils/deadline";
import { submissionOf } from "../../utils/response";
import { describeRfq, responseModeLabel } from "../../utils/rfqCardCopy";

interface SubmittedPanelProps {
  rfq: VendorRfqDetail;
  now: number;
  canWithdraw: boolean;
  onWithdraw: () => void;
}

export default function SubmittedPanel({ rfq, now, canWithdraw, onWithdraw }: SubmittedPanelProps) {
  const copy = describeRfq(rfq, now);
  const submitted = submissionOf(rfq);
  if (!submitted) return null;

  return (
    <Box sx={{ backgroundColor: "white", border: `1px solid ${V2_COLORS.border}`, borderRadius: "8px", p: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap">
        <Typography fontSize="14px" fontWeight={600}>
          {`Submitted · under evaluation · decision by ${formatDay(submitted.decision_expected_by)}`}
        </Typography>
        <Chip size="small" label={responseModeLabel(submitted.mode)} variant="outlined" />
        {copy.countdown && <Chip size="small" label={copy.countdown} sx={{ fontWeight: 600, color: V2_COLORS.warning, backgroundColor: V2_COLORS.warningBg }} />}
      </Stack>
      <Stack direction="row" spacing={4} sx={{ mt: 1.5 }} flexWrap="wrap">
        <Box>
          <Typography fontSize="11px" sx={{ color: V2_COLORS.textSecondary, textTransform: "uppercase", letterSpacing: "0.5px" }}>
            Your total
          </Typography>
          <Typography fontSize="16px" fontWeight={700}>
            {formatMoney(submitted.bid_total)}
          </Typography>
        </Box>
        <Typography fontSize="12px" sx={{ color: V2_COLORS.textSecondary, alignSelf: "flex-end" }}>
          {`Submitted ${formatRespondBy(submitted.submitted_at)}`}
        </Typography>
      </Stack>
      <Box sx={{ mt: 2 }}>
        {canWithdraw ? (
          <Button variant="outlined" onClick={onWithdraw} sx={{ textTransform: "none", fontWeight: 600 }}>
            Withdraw & edit
          </Button>
        ) : (
          <Typography fontSize="13px" sx={{ color: V2_COLORS.textSecondary }}>
            {copy.windowOpen ? "Withdrawing is not available for this response." : "The response window has closed. Your submission stands."}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
